import Hamburguer from "../../../assets/images/generico/Hamburguer";
import Notifications from "../Notifications/Notifications";
import HeaderTimer from "../HeaderTimer/HeaderTimer";
import camelize from "../../../../global/utils/camelize";
import defaultPerfil from "../../../assets/images/generico/defaultUserImage.png";
import { getStrDate } from "../../../../global/utils/diasData";
import { useHistory } from "react-router";
import React, { useContext, useState, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import "./HeaderbarHome.css";
import { misMedicosReset } from "../../../context/Actions/misMedicos/misMedicos";
import { misInformesReset } from "../../../context/Actions/misInformes/misInformes";
import { misLaboratoriosReset } from "../../../context/Actions/misLaboratorios/misLaboratorios";
import { resetTurnosPaciente } from "../../../context/Actions/turnos/turnosPaciente";
import { grupoFamiliarReset } from "../../../context/Actions/grupoFamiliar/grupoFamiliar";
import { localidadReset } from "../../../context/Actions/localidad/localidad";
import { resetMultitab } from "../../../context/Actions/multiTab/multiTab";
import { resetLaboGrupo } from "../../../context/Actions/laboGrupo/laboGrupo";
import { resetEstudioGrupo } from "../../../context/Actions/estudioGrupo/estudioGrupo";
import { resetListaFamiliares } from "../../../context/Actions/listaFamiliares/listasFamiliares";
import { tokenLogout } from "../../../context/Actions/token/logoutToken";
import { recetasDigitalesReset } from "../../../context/Actions/turnos/recetaDigital";
import { resetDropdown } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { GlobalContext } from "../../../../global/context/Provider";
import { logoutApp } from "../../../../global/context/action/auth/logoutApp";
import {
  HeaderBarMainContainer,
  MenuContainerMobile,
} from "./localStyle";
import isIosNative from "../../../../global/utils/isIosNative";
import { wsPostLogoutTraza } from "global/context/action/auth/loginTraza";
import IconBlack from "_+_Portal/assets/images/generico/IconBack";
import isAuthenticated from "global/utils/isAuthenticated";

const HeaderbarHome = ({ turnos, onShowBurguerHandle, handleClickVolver }) => {
  const history = useHistory();
  const {
    multiTabDispatch,
    misMedicosDispatch,
    misInformesDispatch,
    misLaboratoriosDispatch,
    turnosPacienteDispatch,
    grupoFamiliarDispatch,
    localidadDispatch,
    laboGrupoDispatch,
    estudioGrupoDispatch,
    listaFamiliaresDispatch,
    tokenDispatch,
    recetasDigitalesDispatch,
    selectDropDownDispatch,
    resetPortalContext,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, authDispatch, configState, resetGlobalContext } =
    useContext(GlobalContext);
  // const { resetAdminContext} = useContext(AdminContext);

  const [showDropPerfil, setShowDropPerfil] = useState(false);
  const [iosInfo, setIosInfo] = useState(false);

  // Detectar iOS de forma segura con cleanup
  useEffect(() => {
    let isMounted = true;

    async function infoIos() {
      try {
        const isIosNativeMobile = await isIosNative.logDeviceInfo();
        // Solo actualizar estado si el componente sigue montado
        if (isMounted) {
          setIosInfo(isIosNativeMobile);
        }
      } catch (error) {
        console.error("Error detecting iOS:", error);
      }
    }

    infoIos();

    // Cleanup: marcar como desmontado
    return () => {
      isMounted = false;
    };
  }, []);

  const imgAvatar =
    authState.auth.data && authState?.auth?.data?.paciente?.imagenPerfil;

  const nameCamelized = () => {
    if (authState.auth.data) {
      let name = authState?.auth?.data?.paciente?.nombre;
      return camelize(name);
    }
  };

  const onHandleClickAvatar = () => {
    if (!showDropPerfil) {
      setShowDropPerfil(true);
    } else {
      setShowDropPerfil(false);
    }
  };

  const onHandleVerPerfil = () => {
    history.push("/perfil");
  };

  let config = localStorage.getItem("config");
  let opcResetContext = JSON.parse(config).opcResetContext;

  const onHandleSalir = () => {
    if (authState.authTraza.data !== null) {
      wsPostLogoutTraza(authState.authTraza.data.id, {
        ingreso: false,
        sector: configState.config.data.sectorTurno,
      })(authDispatch);
    }
    if (opcResetContext) {
      resetPortalContext(0);
      resetGlobalContext(0);
      history.push("/");
    } else {
      logoutApp(history)(authDispatch);
      tokenLogout(history)(tokenDispatch);
      misMedicosReset()(misMedicosDispatch);
      misInformesReset()(misInformesDispatch);
      misLaboratoriosReset()(misLaboratoriosDispatch);
      resetTurnosPaciente()(turnosPacienteDispatch);
      grupoFamiliarReset()(grupoFamiliarDispatch);
      localidadReset()(localidadDispatch);
      resetMultitab()(multiTabDispatch);
      resetLaboGrupo()(laboGrupoDispatch);
      resetEstudioGrupo()(estudioGrupoDispatch);
      resetListaFamiliares()(listaFamiliaresDispatch);
      recetasDigitalesReset()(recetasDigitalesDispatch);
      resetDropdown()(selectDropDownDispatch);
    }
    localStorage.setItem("alertaActive", true);
  };

  return (
    <React.Fragment>
      <div
        className={`ptur-HeaderbarDiv-background ${!showDropPerfil ? "disable" : ""
          }`}
        onClick={onHandleClickAvatar}
      ></div>
      <HeaderBarMainContainer className="c-white" $isIos={iosInfo}>
        {turnos ? (
          <button
            className="ptur-headerbarFiltros-volverBtn"
            onClick={handleClickVolver}
          >
            <IconBlack />
            <span className="ptur-headerbarFiltros-volverTxt rb18m">
              VOLVER
            </span>
          </button>
        ) : (
          <div className="logoHeader">
            <img
              className="ptur-logoHeader"
              src={
                process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"
              }
              alt="logo"
            ></img>
          </div>
        )}
        <div className="ptur-RightMenu">
          {/* Fecha/hora visible solo en desktop */}
          <div className="ptur-headerBarHome-DiaHora">
            <p id="ptur-DiaResponsive" className="rb18m">
              {getStrDate(new Date())}
              <span className="ptur-timer">
                <HeaderTimer />
              </span>
            </p>
          </div>
          {/* WhatsApp pill button - visible solo en mobile */}
          {isAuthenticated() && JSON.parse(config)?.opcBot !== false && (
            <a
              href="https://wa.me/5491166485555"
              target="_blank"
              rel="noopener noreferrer"
              className="ptur-headerBarHome-whatsapp"
              aria-label="Contactar por WhatsApp"
            >
              <svg className="ptur-whatsapp-svg" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              <span className="ptur-whatsapp-text">WhatsApp</span>
            </a>
          )}
          <Notifications />
          <div className="ptur-perfilMenu">
            <div
              onClick={onHandleClickAvatar}
              className="ptur-flechaAvatar-box"
            >
              <div className="ptur-perfilMenu-perfilImg-box">
                <img
                  className={
                    showDropPerfil
                      ? `ptur-perfilMenu-perfilImg-img clickedAvatar`
                      : `ptur-perfilMenu-perfilImg-img`
                  }
                  src={
                    imgAvatar
                      ? `data:image/jpeg;base64,${imgAvatar}`
                      : defaultPerfil
                  }
                  alt="Perfil"
                />
              </div>
              <div style={{ position: showDropPerfil && "relative" }}>
                <div className="profile-container">
                  <div
                    className={`profile-menu ${showDropPerfil ? "open" : ""}`}
                  >
                    <div className="menu-title">
                      <div className="boxImg">
                        <img
                          className={`roundedImg`}
                          src={
                            imgAvatar
                              ? `data:image/jpeg;base64,${imgAvatar}`
                              : defaultPerfil
                          }
                          alt="Perfil"
                        />
                      </div>
                      <div>
                        <p className="rb16m c-latex10">{nameCamelized()}</p>
                        <p className="rb12l c-latex10 truncated-text">
                          {authState?.auth?.data?.paciente?.email}
                        </p>
                      </div>
                    </div>
                    <div className="menu-item" onClick={onHandleVerPerfil}>
                      <span className="rb14l">Mi Perfil</span>
                    </div>
                    <hr className="lineaSeparadora" />
                    {/* <div class="notification-container">
                      {notiData.map(n =>
                        <Link to={n.link.url} key={n.id} className="menu-item notification-item menu-item-left-bordered">
                          <span className="notification-date">{n.fecha}</span>
                          <span className="notification-description">{n.descripcion}</span>
                        </Link>
                      )}
                    </div>*/}
                    <hr className="lineaSeparadora" />
                    <div className="menu-item" onClick={onHandleSalir}>
                      <span className="rb14l">Cerrar Sesión</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={onShowBurguerHandle}
            className="ptur-burguerPerfil pointer"
          >
            <MenuContainerMobile>
              <Hamburguer />
            </MenuContainerMobile>
          </div>
        </div>
      </HeaderBarMainContainer>
    </React.Fragment>
  );
};

export default HeaderbarHome;
